/*
 *
 * GenericPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 04-Oct-2024
 */

import GenericPopUp from './GenericPopUpContainer'

export default GenericPopUp
